import { InputNumber as InputNumberA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useFormatValue } from './hooks';

type P = {
  fullWidth?: boolean;
  useFormatter?: boolean;
} & ComponentProps<typeof InputNumberA<number>>;

const InputNumber = ({ className, fullWidth, useFormatter, ...rest }: P) => {
  const { formatter, parser } = useFormatValue();

  return (
    <InputNumberA
      className={cn(className, 'input-number', { 'input-number--full-width': fullWidth })}
      formatter={useFormatter ? formatter : undefined}
      parser={useFormatter ? parser : undefined}
      size="large"
      {...rest}
    />
  );
};

export default InputNumber;
